import React from 'react';

function Pulse({ className = '' }) {
  return <div className={`animate-pulse bg-gray-200 rounded ${className}`} />;
}

function TableSkeleton({ rows = 5 }) {
  return (
    <div className="space-y-3">
      <div className="flex gap-4">
        {[1, 2, 3, 4].map((i) => (
          <Pulse key={i} className="h-4 flex-1" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 py-3 border-b border-gray-100">
          {[1, 2, 3, 4].map((j) => (
            <Pulse key={j} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}

function CardsSkeleton({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-lg p-6 shadow-sm">
          <Pulse className="h-4 w-24 mb-3" />
          <Pulse className="h-8 w-16 mb-2" />
          <Pulse className="h-3 w-32" />
        </div>
      ))}
    </div>
  );
}

function FormSkeleton({ fields = 6 }) {
  return (
    <div className="space-y-6">
      {Array.from({ length: fields }).map((_, i) => (
        <div key={i}>
          <Pulse className="h-4 w-24 mb-2" />
          <Pulse className="h-10 w-full" />
        </div>
      ))}
      <div className="flex gap-3 pt-4">
        <Pulse className="h-10 w-24" />
        <Pulse className="h-10 w-24" />
      </div>
    </div>
  );
}

function DetailSkeleton() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Pulse className="h-12 w-12 rounded-full" />
        <div className="flex-1">
          <Pulse className="h-6 w-48 mb-2" />
          <Pulse className="h-4 w-32" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i}>
            <Pulse className="h-3 w-20 mb-2" />
            <Pulse className="h-5 w-full" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function LoadingSkeleton({ variant = 'table', rows, count, fields }) {
  let content;
  switch (variant) {
    case 'table':
      content = <TableSkeleton rows={rows} />;
      break;
    case 'cards':
      content = <CardsSkeleton count={count} />;
      break;
    case 'form':
      content = <FormSkeleton fields={fields} />;
      break;
    case 'detail':
      content = <DetailSkeleton />;
      break;
    default:
      content = <TableSkeleton rows={rows} />;
  }
  return <div data-testid="loading-skeleton">{content}</div>;
}
